<template>
  <div class="w-full bg-legal">
    <div class="py-20 px-4 lg:px-24">
      <h1 class="font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28">Domestic, Family and Sexual Violence Support</h1>
      <div class="w-full md:max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-dark to-brand-primary-light p-0.5 shadow-md border-none hover:border-solid hover:border-2 hover:border-white hover:text-white">
            <button
              class="flex-1 text-lg md:text-18 bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer"
              onclick="javascript:window.location.replace('https://recipetineats.com')"
            >
                <a class="no-underline text-black" href="https://recipetineats.com/">Quick Exit</a>
            </button>
        </div>
    </div>
  </div>

  <div class="bg-white">
    <div class="pl-4 lg:pl-20 py-14 font-poppins">
      <div>
        <p class="pb-2">
          <a
            href="/"
            class="text-primary"
          >&lt; Back to home
          </a>
        </p>
        <h3 class="font-poppins-bold">Support Contact Details</h3>
        <div>
            <p class="font-bold my-0">
              If you are in immediate danger, call emergency services on 000.
            </p>
            <p class="mt-0 mb-5">
              If you are experiencing domestic, family or sexual violence, Nexee is here to support you.
            </p>
            <p class="font-bold pb-0 my-0">
              How to contact us
            </p>
            <p class="mt-0 mb-1">
              You can contact us for confidential assistance during business hours:
            </p><p class="m-0 pl-4">
              <strong>Phone:</strong> {{ brandService.getSupportPhoneNumber() }}
            </p><p class="m-0 pl-4">
              <strong>Email:</strong> {{ brandService.getSupportEmail() }}
            </p><p class="mb-0">
              Accessibility support is available:
              <ul class="list-disc my-0">
                <li class="my-0">National Relay Service: via the Access Hub</li>
                <li>Interpreting services: Translating and Interpreting Service (TIS National) on 131 450</li>
              </ul>
            </p><p class="mb-5">
              You can request a call-back and let us know your preferred and safest way to communicate.
            </p>
            <p class="font-bold my-0 py-0">
              External support services
            </p>
            <p class="my-0 py-0">
              You can also access free, confidential support from specialist services, including:
              <ul class="list-disc my-0 py-0">
                <li><strong>1800RESPECT</strong> – 1800 737 732 (24/7 counselling and support)</li>
                <li><strong>Full Stop Australia </strong>– 1800 385 578 (24/7 sexual, domestic and family violence support)</li>
                <li><strong>Lifeline </strong>– 13 11 14 (24/7 crisis support)</li>
                <li><strong>13YARN</strong> – 13 92 76 (24/7 First Nations support)</li>
              </ul>
            </p>
          </div>

          <Accordion :title="'Our Domestic, Family and Sexual Violence Statement'">
          <p class="font-bold pt-4">
            Our commitment to your safety
          </p>
          <p class="mb-5">
            Uniti Retail Pty Ltd (ACN 154 074 218), trading as Nexee Internet, has policies and procedures in place to protect the safety, privacy and wellbeing of customers affected by domestic and family violence or non-domestic sexual violence.
          </p>
          <p class="mb-5">
            We recognise that access to safe and reliable telecommunications is essential for safety, connection and recovery. We are committed to supporting affected persons in a respectful, trauma-informed way and to keeping customers connected to their services wherever possible.
          </p>

          <p class="font-bold">
            Keeping you connected
          </p>
          <p class="mb-5">
            If your telecommunications service has been restricted, suspended or disconnected and you tell us, this raises concerns about your safety. We will act as a matter of urgency to reverse that action. If reversal is not practical, we will offer an equivalent telecommunications service where available.
          </p>

          <p class="font-bold">
            Financial hardship support
          </p>
          <p class="mb-5">
            We recognise that domestic, family or sexual violence can be a reason for non-payment. Customers affected by DFSV may be entitled to financial hardship assistance under the Telecommunications (Financial Hardship) Standard 2024. We will work with you to discuss available support options.
          </p>

          <p class="font-bold">
            How we can support you
          </p>
          <p class="mb-5">
            With your consent, we can provide additional support which may include:
            <ul class="list-disc">
              <li>agreeing on a safe way and time to contact you</li>
              <li>applying a confidential DFSV safety flag to your account</li>
              <li>taking extra steps to protect access to your personal information</li>
              <li>reviewing fees, charges or credit actions that may affect your safety</li>
            </ul>
            You do not need to share details of the violence to receive support.
          </p>
          <p class="mb-5">
            You can contact us or external support services via the details above.
          </p>
          <p class="font-bold">
            Further information
          </p>
          <p class="mb-5">
            Our
            <a
            :href="`/family-violence`"
              class="text-primary"
              target="_blank"
            >DFSV Customer Policy</a> provides more detail about how we support customers experiencing domestic, family or sexual violence and is available on our website.
          </p>
        </Accordion>
        <h3 class="text-primary text-left pt-5 font-poppins-bold">
          <a
            :href="`/family-violence`"
            class="text-primary"
            target="_blank"
          >Nexee’s Domestic, Family and Sexual Violence Policy</a>
        </h3>

      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import Accordion from '@/components/library/Accordion.vue';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();
</script>
<style scoped>
.bg-legal {
  background-repeat: no-repeat;
  background-color: transparent;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/legal-bg.png");
  background-position: center center;
  background-size: cover;
  height: 100%;
}
</style>
